import { render, staticRenderFns } from "./HoldingShareOptions.vue?vue&type=template&id=4852e412&scoped=true&"
import script from "./HoldingShareOptions.vue?vue&type=script&lang=js&"
export * from "./HoldingShareOptions.vue?vue&type=script&lang=js&"
import style0 from "./HoldingShareOptions.vue?vue&type=style&index=0&id=4852e412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4852e412",
  null
  
)

export default component.exports